export async function ensureNotificationPermission() {
  if (!("Notification" in window)) return false;

  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;

  const perm = await Notification.requestPermission();
  return perm === "granted";
}

export async function showNotificationBoundToThisTab({
  title,
  body,
  url,
  tag,
}) {
  const ok = await ensureNotificationPermission();
  if (!ok) return false;

  if (!("serviceWorker" in navigator)) {
    new Notification(title, { body });
    return true;
  }

  const reg = await navigator.serviceWorker.ready;
  const visibility = document.visibilityState; // "visible" o "hidden"

  reg.active?.postMessage({
    type: "SHOW_NOTIFICATION",
    payload: {
      title,
      originVisibility: visibility,
      options: {
        body,
        tag,
        renotify: true,
        data: { url },
      },
    },
  });

  return true;
}
